import { api } from "@/builders/axios";

const get = function (id: number) {
  return api.get<{
    title: string;
  }>(`courses/module/${id}`);
};

const put = function (id: number, data: { title: string }) {
  return api.put(`/courses/module/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/courses/module/${id}`);
};

export const id = {
  get,
  put,
  del,
};
